import React from 'react';
import * as styles from './Container.module.scss';
var Container = function Container(_ref) { var children = _ref.children; return /*#__PURE__*/ React.createElement("div", { className: styles.container }, children); };
export default Container;
